// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hero__Hero-module--GXU0k {
    padding: var(--space-2xl) var(--space-md) var(--space-3xl);
    background: var(--color-surface-base);
}

.inner__Hero-module--uX1Qe {
    max-width: 1200px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: 1fr;
    align-items: center;
    gap: var(--space-2xl);
}

@media (min-width: 768px) {
    .inner__Hero-module--uX1Qe {
        grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    }
}

.text__Hero-module--rQ9rp {
    display: flex;
    flex-direction: column;
    gap: var(--space-lg);
}

.heading__Hero-module--zG7_H {
    width: fit-content;
    max-width: 100%;
    margin: 0;
    font-size: var(--home-text-hero);
    line-height: 0.95;
    font-weight: 800;
    letter-spacing: -0.03em;
}

/*
 * The Cambridge text logo, following the Cambridge brand guidelines as the header does (Layout.module.css):
 * black on the light background, with nothing behind it. The supplied file is white, so the filter renders it
 * black. It used to sit on an orange panel, which the guidelines do not allow.
 */
.highlight__Hero-module--aKVhw {
    display: block;
}

.highlightLogo__Hero-module--ilnud {
    display: block;
    height: 0.34em;
    width: auto;
    margin-inline: auto;
    filter: brightness(0);
}

.headingLine__Hero-module--ACQoR {
    display: block;
    margin-top: var(--space-xs);
}

/* Sized by height now the panel no longer sets the heading's width; about the size it was beside the panel. */
.headingLogo__Hero-module--BTGc_ {
    display: block;
    height: 0.62em;
    width: auto;
    max-width: 100%;
    margin-inline: auto;
}

/* An edition under the wordmark, e.g. "CAPS Edition" on the South African site. */
.edition__Hero-module--nxlc4 {
    display: block;
    margin-top: var(--space-xs);
    font-size: 0.4em;
    letter-spacing: -0.01em;
    text-align: center;
    color: var(--color-text-primary);
}

.standfirst__Hero-module--rk5lC {
    margin: 0;
    max-width: 520px;
    font-size: clamp(18px, 1.6vw, 21px);
    line-height: 1.55;
    color: var(--color-text-secondary);
}

.actions__Hero-module--fZ0MT {
    display: flex;
    flex-wrap: wrap;
    gap: var(--space-sm);
}

.visualWrap__Hero-module--D1ZnI {
    position: relative;
    padding: var(--space-md) var(--space-sm);
}
`, "",{"version":3,"sources":["webpack://./src/main/ui/home/components/Hero.module.css"],"names":[],"mappings":"AAAA;IACI,0DAA0D;IAC1D,qCAAqC;AACzC;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,0BAA0B;IAC1B,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI;QACI,oDAAoD;IACxD;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,SAAS;IACT,gCAAgC;IAChC,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;;;;EAIE;AACF;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,WAAW;IACX,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,2BAA2B;AAC/B;;AAEA,8GAA8G;AAC9G;IACI,cAAc;IACd,cAAc;IACd,WAAW;IACX,eAAe;IACf,mBAAmB;AACvB;;AAEA,kFAAkF;AAClF;IACI,cAAc;IACd,2BAA2B;IAC3B,gBAAgB;IAChB,uBAAuB;IACvB,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,mCAAmC;IACnC,iBAAiB;IACjB,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,wCAAwC;AAC5C","sourcesContent":[".hero {\n    padding: var(--space-2xl) var(--space-md) var(--space-3xl);\n    background: var(--color-surface-base);\n}\n\n.inner {\n    max-width: 1200px;\n    margin: 0 auto;\n    display: grid;\n    grid-template-columns: 1fr;\n    align-items: center;\n    gap: var(--space-2xl);\n}\n\n@media (min-width: 768px) {\n    .inner {\n        grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n    }\n}\n\n.text {\n    display: flex;\n    flex-direction: column;\n    gap: var(--space-lg);\n}\n\n.heading {\n    width: fit-content;\n    max-width: 100%;\n    margin: 0;\n    font-size: var(--home-text-hero);\n    line-height: 0.95;\n    font-weight: 800;\n    letter-spacing: -0.03em;\n}\n\n/*\n * The Cambridge text logo, following the Cambridge brand guidelines as the header does (Layout.module.css):\n * black on the light background, with nothing behind it. The supplied file is white, so the filter renders it\n * black. It used to sit on an orange panel, which the guidelines do not allow.\n */\n.highlight {\n    display: block;\n}\n\n.highlightLogo {\n    display: block;\n    height: 0.34em;\n    width: auto;\n    margin-inline: auto;\n    filter: brightness(0);\n}\n\n.headingLine {\n    display: block;\n    margin-top: var(--space-xs);\n}\n\n/* Sized by height now the panel no longer sets the heading's width; about the size it was beside the panel. */\n.headingLogo {\n    display: block;\n    height: 0.62em;\n    width: auto;\n    max-width: 100%;\n    margin-inline: auto;\n}\n\n/* An edition under the wordmark, e.g. \"CAPS Edition\" on the South African site. */\n.edition {\n    display: block;\n    margin-top: var(--space-xs);\n    font-size: 0.4em;\n    letter-spacing: -0.01em;\n    text-align: center;\n    color: var(--color-text-primary);\n}\n\n.standfirst {\n    margin: 0;\n    max-width: 520px;\n    font-size: clamp(18px, 1.6vw, 21px);\n    line-height: 1.55;\n    color: var(--color-text-secondary);\n}\n\n.actions {\n    display: flex;\n    flex-wrap: wrap;\n    gap: var(--space-sm);\n}\n\n.visualWrap {\n    position: relative;\n    padding: var(--space-md) var(--space-sm);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"hero": `hero__Hero-module--GXU0k`,
	"inner": `inner__Hero-module--uX1Qe`,
	"text": `text__Hero-module--rQ9rp`,
	"heading": `heading__Hero-module--zG7_H`,
	"highlight": `highlight__Hero-module--aKVhw`,
	"highlightLogo": `highlightLogo__Hero-module--ilnud`,
	"headingLine": `headingLine__Hero-module--ACQoR`,
	"headingLogo": `headingLogo__Hero-module--BTGc_`,
	"edition": `edition__Hero-module--nxlc4`,
	"standfirst": `standfirst__Hero-module--rk5lC`,
	"actions": `actions__Hero-module--fZ0MT`,
	"visualWrap": `visualWrap__Hero-module--D1ZnI`
};
export default ___CSS_LOADER_EXPORT___;
